 
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import { routes } from "../../../routers/routes";
import GridView from "../../commonComponents/gridView";

const JobRightSidebarContainer = () => {
  return (
    <>
      <Breadcrumbs title="Job Listing" url={routes.Home.JobDemo1} mainClass="job-breadcrumbs-section" />
      <GridView type="job" sectionClass="job-grid-section" filterTagsClass="job-list-header" side="right" />
    </>
  );
};

export default JobRightSidebarContainer;
